export default "__VITE_ASSET__COmsRDLd__"